module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type == 'simple') ? _c('simple', {
    attrs: {
      "contacto": _vm.contacto
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'extend') ? _c('extend', {
    attrs: {
      "contacto": _vm.contacto
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be435bd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactForm/Contact.vue
// module id = 392
// module chunks = 0